import { QueryFilter } from "src/app/shared/models/query-filter.model";

export class LeagueMembersListQueryFilter extends QueryFilter {
    organizationId: string;
    leagueId: string;
}

